import React, { Component } from 'react';
import { TextAreaEditor } from '../../components';
import s from './HostStyles.module.scss';

export default class TextAreaEditorEditor extends Component {
    constructor(props) {
        super(props);
        this.state = { value: '' };
    }

    render() {
        return (
            <div className={s.editor} style={{ padding: '100px' }}>
                <TextAreaEditor
                    placeHolder="put yer text in here..."
                    value={this.state.value}
                    onChange={value => {
                        this.setState({ value });
                    }}
                />
            </div>
        );
    }
}
